import { Collapse, Text, theme } from '@/components';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { type FC, type ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  filterTags: ReactNode;
  searchForm: ReactNode;
  defaultOpen?: boolean;
  onChange?: (open: boolean) => void;
};

export const SearchAccordion: FC<Props> = ({
  filterTags,
  searchForm,
  defaultOpen = false,
  onChange,
}) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Collapse
      accordion
      defaultActiveKey={defaultOpen ? ['search'] : []}
      expandIcon={({ isActive }) =>
        isActive ? (
          <DownOutlined style={{ color: token.colorPrimary, fontSize: 12 }} />
        ) : (
          <RightOutlined style={{ color: token.colorPrimary, fontSize: 12 }} />
        )
      }
      onChange={(e) => {
        setOpen(!!e.length);
        onChange?.(!!e.length);
      }}
      style={{
        background: token.colorBgBase,
        borderRadius: 0,
        marginTop: 16,
      }}
      items={[
        {
          key: 'search',
          style: { borderRadius: 0 },
          label: (
            <>
              <Text color="primary" text={t('search-condition')} />
              {!open && filterTags}
            </>
          ),
          children: searchForm,
        },
      ]}
    />
  );
};
